import { FlowchartConfig } from '../base/flowchart.config';

/**
 * Snaps the center of the given element to the nearest grid position.
 *
 * This method calculates the center of the element and aligns it to the nearest grid position
 * based on the grid size defined in the FlowchartConfig.
 *
 * @param {joint.dia.Element} element - The element to snap to the grid.
 */

export const snapCenterOfElementToGrid = (element: joint.dia.Element) => {
  const bbox = element.getBBox();
  const centerX = bbox.x + bbox.width / 2;
  const centerY = bbox.y + bbox.height / 2;

  const snappedCenterX = getGridMatchedPositionValue(centerX);
  const snappedCenterY = getGridMatchedPositionValue(centerY);

  const newX = snappedCenterX - bbox.width / 2;
  const newY = snappedCenterY - bbox.height / 2;

  element.position(newX, newY);
};

/**
 * Calculates the nearest grid-matched position value.
 *
 * This method takes a position value and aligns it to the nearest grid position
 * based on the grid size defined in the FlowchartConfig.
 *
 * @param {number} positionValue - The original position value to be aligned to the grid.
 * @return {number} - The grid-matched position value.
 */
export const getGridMatchedPositionValue = (positionValue: number): number => {
  const baseNumber = FlowchartConfig.paper.gridSize;
  return Math.ceil(positionValue / baseNumber) * baseNumber;
};
